import "./TableFilters.scss";

import {
  Button,
  Chip,
  DatePicker,
  Input,
  Radio,
  RadioGroup,
  Select,
} from "@trackman/web-shared-components";

import { ReactComponent as FilterIcon } from "assets/images/filter.svg";
import FilterType from "./FilterType";
import { Popper } from "@mui/material";
import { useState } from "react";

export type FiltersData = { current: JSX.Element; contentIcons: JSX.Element[] };

export type FilterChip = {
  id: string;
  chipDescription: string;
  value: string;
  onRemove: (i: number) => void;
};

export const FilterChips = (filters: FilterChip[]) => {
  return filters.length > 0 ? (
    <div className="current-filters">
      {filters.map((f, index) => FChip(f, index))}
    </div>
  ) : (
    <></>
  );
};

const FChip = (f: FilterChip, index: number) => {
  return (
    <div key={index} className="current-filter">
      <Chip
        key={index}
        label={f.chipDescription}
        color="#414141"
        onDelete={() => f.onRemove(index)}
      />
    </div>
  );
};

export const ColumnItems = (filters: FilterType[]) => {
  let lastColumn = filters[0].columnNumber;
  let columnFilters: JSX.Element[] = [];

  filters.forEach((f) => (lastColumn = Math.max(lastColumn, f.columnNumber)));
  for (let k = 0; k < lastColumn + 1; k++) {
    columnFilters.push(Column(filters.find((f) => f.columnNumber === k)));
  }
  return columnFilters;
};

const Column = (f: FilterType | undefined) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  if (!f) return <></>;

  const applyFilter = () => {
    setAnchorElement(null);
    f.onApply();
  };

  const Popup = (f: FilterType) => {
    if (f.type === "textfields")
      return f.inputProps.map((ip, i) => {
        return (
          <Input
            key={i}
            {...ip}
            onKeyPress={(event) => {
              if (event.key === "Enter") applyFilter();
            }}
          />
        );
      });
    if (f.type === "select")
      return <Select {...f.selectProps} ref={undefined} />;
    if (f.type === "date")
      return (
        <div
          onKeyDown={(event) => {
            if (event.key === "Enter") applyFilter();
          }}
        >
          <DatePicker {...f.datePickerProps} />
        </div>
      );
    if (f.type === "date_range")
      return (
        <>
          <div
            onKeyDown={(event) => {
              if (event.key === "Enter") applyFilter();
            }}
          >
            <DatePicker {...f.startDateProps} />
          </div>
          <div
            onKeyDown={(event) => {
              if (event.key === "Enter") applyFilter();
            }}
          >
            <DatePicker {...f.endDateProps} />
          </div>
        </>
      );
    if (f.type === "select-or-input")
      return (
        <>
          <Select {...f.selectProps} ref={undefined} />
          <Input
            {...f.inputProps}
            onKeyPress={(event) => {
              if (event.key === "Enter") applyFilter();
            }}
          />
        </>
      );
    if (f.type === "radio")
      return (
        <RadioGroup>
          {f.radioProps.map((c, i) => (
            <Radio key={i} {...c} margin="3px" />
          ))}
        </RadioGroup>
      );
  };

  return (
    <div
      className="filter-button-and-popup"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="popup-activate-button"
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          setAnchorElement(anchorElement ? null : event.currentTarget);
        }}
      >
        <FilterIcon />
      </div>
      {!!anchorElement && (
        <>
          <div className="backdrop" onClick={() => setAnchorElement(null)} />
          <Popper
            open={true}
            anchorEl={anchorElement}
            popperOptions={{
              placement: "bottom",
              modifiers: [{ options: { tether: true } }],
            }}
            onResize={undefined}
            onResizeCapture={undefined}
          >
            <div className="data-table-filter-content">
              {Popup(f)}
              <Button
                className="apply-button"
                label="Apply"
                intent="primary"
                onClick={() => applyFilter()}
              />
            </div>
          </Popper>
        </>
      )}
    </div>
  );
};
